import { EmphasisBlock, EmphasisBlockProps, media } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledBoldText = styled.span`
  font-weight: bold;
  display: flex;
  flex: 1;

  ${media.sm`
    display: inline-flex;
    flex:0;
  `};
`;

export const StyledDiv = styled.div`
  margin-bottom:36px;
`;

export const StyledEmphasisBlock = styled<FC<EmphasisBlockProps>>(EmphasisBlock)`
  margin-top: 36px;

  ${media.sm`
    padding-right: 32px;
    padding-left: 32px;
  `};
`;
